import React from 'react';
import HamburgerMenu from 'react-hamburger-menu';
import './Header.css';

const nav = props => {
  const assets = process.env.PUBLIC_URL + '/Assets/';
  const {
    locale,
    content: { logo, items },
    isOpen,
    navClick,
    deviceWidth,
    hamClick,
    langClick
  } = props;

  return (
    <header
      className={`section section--header ${
        deviceWidth < 992 ? (isOpen ? 'expand' : 'stack') : ''
      }`}
    >
      <div className="section__wrapper">
        <div className="header__items">
          <img alt="logo" className="header__logo" src={assets + logo} />
          <nav className="header__nav">
            <ul className="nav__items">
              {items.map((el, i) => {
                return (
                  <li className="nav__item" key={i} onClick={() => navClick(el.anchor)}>
                    {el.text}
                  </li>
                );
              })}
              {locale !== 'en_US' && (
                <li className="lang">
                  <ul className="lang__list">
                    <li
                      className={'lang__el' + (locale === 'de_DE' ? ' active' : '')}
                      onClick={() => langClick('de_DE')}
                    >
                      GER
                    </li>
                    <li
                      className={'lang__el' + (locale === 'en_DE' ? ' active' : '')}
                      onClick={() => langClick('en_DE')}
                    >
                      ENG
                    </li>
                  </ul>
                </li>
              )}
            </ul>
            <div className="nav__hamburger">
              <HamburgerMenu
                isOpen={isOpen}
                menuClicked={hamClick}
                width={25}
                height={15}
                strokeWidth={2}
                rotate={0}
                color="#265DA5"
                borderRadius={0}
                animationDuration={0.2}
              />
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default nav;
